import {RateGeneratorApi} from 'Agent/AgentInformation/api';
import {AgentLicenseFilters} from 'Agent/AgentInformation/ducks/agents';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import {AgentLicensesApi} from './api';

const agentLicenseApi = new AgentLicensesApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const rateGeneratorApi = new RateGeneratorApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

export default {
  getAgentLicenses: (
    agentNumbers: string[],
    isNewYork: boolean,
    encryptedIdentifier: string,
    filter?: AgentLicenseFilters
  ) =>
    withCancellation(cancelToken =>
      agentLicenseApi
        .searchAgentLicenses('1', {
          params: {...filter, encryptedIdentifier, agentNumbers, isNewYork},
          ...getAxiosConfig(cancelToken),
        })
        .then(handleResponse)
    ),

  getRateGenerators: (encryptedIdentifier: string) =>
    withCancellation(cancelToken =>
      rateGeneratorApi
        .rateGeneratorGetRateGenerators('1', {
          params: {encryptedIdentifier},
          ...getAxiosConfig(cancelToken),
        })
        .then(handleResponse)
    ),
};
